import { getEnumValues } from './get-enum-values';

export enum SoccerTimelinePeriod {
	FirstHalf = 'First Half',
	SecondHalf = 'Second Half',
}

export const SoccerTimelinePeriodValues = getEnumValues <SoccerTimelinePeriod>(SoccerTimelinePeriod)
